import { lazy } from 'react';

import Loadable from 'components/Loadable';

const SignIn = Loadable(lazy(() => import('modules/sign-in')));

export const route = { path: 'sign-in', element: <SignIn /> };
